import DetailStatTiles from "@/app/admin/_common/DetailStatTiles";
import type { PromoKpis } from "@/app/_services/PromoService";

// Cents matter here — a small discount would otherwise round away to "$0" while the
// per-show breakdown below shows the real figure.
const currencyFormat = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
const numberFormat = new Intl.NumberFormat("en-US");

export default function PromoStatTiles({ kpis }: { kpis: PromoKpis }) {
  return (
    <DetailStatTiles
      columns={5}
      tiles={[
        { label: "Uses", value: numberFormat.format(kpis.uses), caption: "Orders" },
        { label: "Tickets", value: numberFormat.format(kpis.tickets), caption: "Tickets sold" },
        {
          label: "Total discount",
          value: currencyFormat.format(kpis.discount_amount),
          caption: "Off list price",
        },
        { label: "Shows", value: numberFormat.format(kpis.shows_used), caption: "Shows used on" },
        {
          label: "Unique guests",
          value: numberFormat.format(kpis.unique_guests),
          caption: "Distinct guests",
        },
      ]}
    />
  );
}
